import React, { useCallback } from 'react';
import clsx from 'clsx';
import Depot from '../../_shared/depot';
import * as styles from './style.module.css';
const TabNavLinkWithoutRef = ({ tabKey, label, active, onTabClick, icon: Icon, activePosition, scrollable, className, tabRef, ...commonProps }) => {
    const tabClasses = clsx(styles.tabLinkButton, active && styles.tabLinkActive, scrollable && styles.withScroll);
    const tabLineClasses = clsx(styles.tabLinkLine);
    const tabLabelClass = clsx(styles.tabLabel);
    const handleTableClick = useCallback((event) => {
        onTabClick(tabKey, event);
    }, [onTabClick, tabKey]);
    return Depot.createElement('button', {
        ...commonProps,
        id: `tab-${tabKey}`,
        role: 'tab',
        'aria-controls': `tabpanel-${tabKey}`,
        'aria-selected': active,
        'data-tab-key': tabKey,
        onClick: handleTableClick,
        className: clsx(className, tabClasses),
    }, React.createElement(React.Fragment, null,
        Icon && React.createElement(Icon, { size: 24 }),
        React.createElement("span", { className: tabLabelClass }, label),
        active && React.createElement("div", { className: tabLineClasses, style: activePosition })));
};
const TabNavLink = Depot.withRef(TabNavLinkWithoutRef);
TabNavLink.displayName = 'TabNavLink';
export default TabNavLink;
//# sourceMappingURL=index.js.map